export default "__VITE_ASSET__D2lhUoRm__"